import React, { useState, useEffect } from 'react';
import { Card, message, Empty, Spin } from 'antd';
import { FileTextOutlined, EyeOutlined, InboxOutlined } from '@ant-design/icons';
import { getPolicies } from '../../API/index';
import './styles.css';
import './../../Components/common/headerStyles.css';

const { Meta } = Card;

const ArchivedPolicy = () => {
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPolicies();
  }, []);

  const token = localStorage.getItem("token");
  let isAdmin = false;
  if (token) {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      isAdmin = payload.isAdmin;
      console.log(isAdmin);
    } catch (error) {
      console.error("Error decoding token:", error);
    }
  }

  const fetchPolicies = async () => {
    try {
      const response = await getPolicies();
      // Filter out archived policies before setting the state
      const filteredPolicies = response.data.filter((policy) => policy.isArchived===true);
      setPolicies(filteredPolicies);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching policies:', error);
      message.error('Failed to fetch policies');
    }
  };

  const handleCardClick = (fileUrl) => {
    window.open(fileUrl, '_blank');
  };

  return (
    <div className="archived-container">
      <div className="page-header">
        <h1 className="page-title">
          <InboxOutlined /> Archived Policies
        </h1>
        <p className="page-subtitle">Access historical company policies</p>
      </div>

      <div className="archived-grid">
        {loading ? (
          <div className="loading-container">
            <Spin size="large" />
          </div>
        ) : policies.length > 0 ? (
          policies.map((policy) => (
            <Card
              key={policy._id}
              hoverable
              className="archived-card"
              cover={
                <div className="archived-cover">
                  <div className="archived-badge">Archived</div>
                  <FileTextOutlined className="archived-icon" />
                  <div className="archived-overlay">
                    <EyeOutlined className="view-icon" />
                  </div>
                </div>
              }
              onClick={() => handleCardClick(policy.fileUrl)}
            >
              <Meta
                title={<div className="archived-card-title">{policy.title}</div>}
                description={
                  <div className="archived-actions">
                    <button className="view-archived-btn">
                      View Archive
                    </button>
                  </div>
                }
              />
            </Card>
          ))
        ) : (
          <div className="empty-state">
            <Empty
              image={<InboxOutlined style={{ fontSize: 64, color: '#bfbfbf' }} />}
              description={
                <span className="empty-text">No archived policies found</span>
              }
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ArchivedPolicy;
